var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 224.674,
    height: 226.511,
    viewBox: "0 0 224.674 226.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_notification_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 618",
    width: 159.958,
    height: 166.205,
    rx: 23,
    fill: "#e6ae4f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 23",
    transform: "matrix(-0.839, 0.545, -0.545, -0.839, 224.674, 139.391)",
    clipPath: "url(#arrow_notification_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6908",
    d: "M134.946,79.071l-61.02,58.894c-6.308,5.925-15.9.439-15.982-9.388l-.173-19.869c-.055-6.364-3.6-11.986-8.849-12.03L9.93,96.355C4.682,96.314.349,91.649.292,85.093L.02,53.85c-.054-6.172,4.192-11.536,9.44-11.492l38.991.322c5.246.043,8.7-4.943,8.646-11.305l-.173-19.864c-.084-9.643,9.41-14.963,15.662-8.934l61.883,58.364A12.833,12.833,0,0,1,134.946,79.071Z",
    transform: "translate(0.531 24.574) rotate(-9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNotification);
export default __webpack_public_path__ + "static/media/arrow_notification.bba81758.svg";
export { ForwardRef as ReactComponent };